import 'magnific-popup'
import "slick-carousel"

export default {
	init() {

		let trMenuGallery = $(".tr-menu-gallery")
		
		if (!trMenuGallery.length) return; 

		trMenuGallery.each(function () {
			const $gallery = $(this)

			if (!$gallery.data("trMenuPopupInitialized")) {
				$gallery.magnificPopup({
					delegate: ".slick-slide:not(.slick-cloned) a",
					type: "image",
					closeOnContentClick: false,
					closeBtnInside: false,
					mainClass: "mfp-with-zoom mfp-img-mobile",
					image: {
						verticalFit: true,
						titleSrc: function (item) {
							if (
								item.el.data("description") &&
								item.el.attr("title")
							) {
								return (
									item.el.data("description") +
									" | " +
									item.el.attr("title")
								)
							} else if (item.el.data("description")) {
								return item.el.data("description")
							} else if (item.el.attr("title")) {
								return item.el.attr("title")
							}
						},
					},
					gallery: {
						enabled: true,
					},
					zoom: {
						enabled: true,
						duration: 300, // don't foget to change the duration also in CSS
						opener: function (element) {
							return element.find("img")
						},
					},
				})

				$gallery.data("trMenuPopupInitialized", true)
			}

			if (!$gallery.hasClass("slick-initialized")) {
				$gallery.slick({
					slidesToShow: 1,
					nextArrow: '<div class="slider-next"></div>',
					prevArrow: '<div class="slider-prev"></div>',
					dots: false,
					variableWidth: true,
					infinite: false,
				})
			}
		})

	}
}
